import { createAction, props } from '@ngrx/store';
import { Principal } from '../models/object.models';

export const loadCompanyPrincipals = createAction(
  '[Core] Load Company Principals',
  props<{
    companyId: string;
    page: number;
    query: string;
    objectClassId: number[];
  }>(),
);

export const loadCompanyPrincipalsSuccess = createAction(
  '[Core] Load Company Principals Success',
  props<{ principals: Principal[]; totalItems: number; page: number }>(),
);

export const loadCompanyPrincipalsFail = createAction(
  '[Core] Load Company Principals Fail',
  props<{ error: any }>(),
);

export const togglePrincipalSelection = createAction(
  '[Core] Toggle Principal Selection',
  props<{ principal: Principal; singleSelection: boolean }>(),
);

export const initializeSelectedPrincipals = createAction(
  '[Principals] Initialize Selected Principals',
  props<{ principals: Principal[] }>(),
);

export const toggleAllPrincipalSelection = createAction(
  '[Core] Toggle All Principal Selection',
  props<{
    principals: Principal[];
    selected: boolean;
  }>(),
);

export const resetPrincipalsState = createAction(
  '[Principals] Reset Principals State',
);

export const clearSelectedPrincipals = createAction(
  '[Principals] Clear Selected Principals',
  props<{ companyId: string }>(),
);

// ! ACTIONS FOR ORIGINAL vs TEMPORARY STATE MANAGEMENT
export const setOriginalPrincipals = createAction(
  '[Principals] Set Original Principals',
  props<{ principals: Principal[] }>(),
);

export const addTemporaryPrincipal = createAction(
  '[Principals] Add Temporary Principal',
  props<{ principal: Principal }>(),
);

export const removeTemporaryPrincipal = createAction(
  '[Principals] Remove Temporary Principal',
  props<{ principalId: string }>(),
);

export const clearTemporaryChanges = createAction(
  '[Principals] Clear Temporary Changes',
);

// ! NESTED TRANSIENT STATE ACTIONS (for child popup cancel/select behavior)
export const snapshotTemporaryChanges = createAction(
  '[Principals] Snapshot Temporary Changes',
);

export const restoreTemporaryChanges = createAction(
  '[Principals] Restore Temporary Changes',
);

export const commitTemporaryChanges = createAction(
  '[Principals] Commit Temporary Changes',
);

export const setCurrentCompany = createAction(
  '[Principals] Set Current Company',
  props<{ companyId: string | null | undefined }>(),
);
// ! EDIT MODE INITIALIZATION - bypasses company change cleanup logic
export const initializeCompanyWithPrincipals = createAction(
  '[Principals] Initialize Company With Principals',
  props<{ companyId: string | null | undefined; principals: Principal[] }>(),
);
